import type { ShapeInsertKind } from '@/components/canvas/elements/shape/toolbar/shapeInsertKinds';
import type { TextBlockKind } from '@/components/canvas/elements/text/utils/textContent';
import type { SliceDeps } from '../deps';

const deactivateOtherDrawTools = {
  penToolActive: false,
  freehandToolActive: false,
  eraserToolActive: false,
};

export function createToolsSlice({ set, mutate, nextZ }: SliceDeps) {
  return {
    setTextDrawMode: (kind: TextBlockKind | null) =>
      set({
        textDrawMode: kind,
        ...(kind ? { shapeDrawKind: null, tableDrawMode: false, ...deactivateOtherDrawTools } : {}),
      }),

    setTableDrawMode: (active: boolean) =>
      set({
        tableDrawMode: active,
        ...(active
          ? { textDrawMode: null, shapeDrawKind: null, ...deactivateOtherDrawTools }
          : {}),
      }),

    setShapeDrawKind: (kind: ShapeInsertKind | null) =>
      set({
        shapeDrawKind: kind,
        ...(kind ? { textDrawMode: null, tableDrawMode: false, ...deactivateOtherDrawTools } : {}),
      }),

    setPenToolActive: (active: boolean) =>
      set({
        penToolActive: active,
        ...(active
          ? {
              shapeDrawKind: null,
              textDrawMode: null,
              tableDrawMode: false,
              freehandToolActive: false,
              eraserToolActive: false,
            }
          : {}),
      }),

    setFreehandToolActive: (active: boolean) =>
      set({
        freehandToolActive: active,
        ...(active
          ? {
              shapeDrawKind: null,
              textDrawMode: null,
              tableDrawMode: false,
              penToolActive: false,
              eraserToolActive: false,
            }
          : {}),
      }),

    setEraserToolActive: (active: boolean) =>
      set({
        eraserToolActive: active,
        ...(active
          ? {
              shapeDrawKind: null,
              textDrawMode: null,
              tableDrawMode: false,
              penToolActive: false,
              freehandToolActive: false,
            }
          : {}),
      }),

    setFreehandStrokeColor: (color: string) => set({ freehandStrokeColor: color }),
    setFreehandStrokeWidth: (width: number) => set({ freehandStrokeWidth: width }),
    setEraserSize: (size: number) => set({ eraserSize: size }),

    mediaImageDropTargetPageId: null as string | null,
    setMediaImageDropTargetPageId: (pageId: string | null) =>
      set({ mediaImageDropTargetPageId: pageId }),

    deleteElementsByIds: (ids: string[]) => {
      if (ids.length === 0) return;
      const toDelete = new Set(ids);
      mutate((draft) => {
        for (const page of draft.pages) {
          const before = page.elements.length;
          page.elements = page.elements.filter((el) => !toDelete.has(el.id));
          if (page.elements.length !== before) {
            page.updatedAt = Date.now();
          }
        }
        draft.workspaceElements = draft.workspaceElements.filter((el) => !toDelete.has(el.id));
      });
    },
  };
}
